import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { ParagraphMetrics as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphMetricsProps {
  id: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphMetrics: React.FC<ParagraphMetricsProps> = ({ id, entity }) => {
  const paragraphMetrics = entity.toJS();

  const title = paragraphMetrics.field_title[0]?.value;
  const body = paragraphMetrics.field_body[0]?.processed;
  const metricItems = paragraphMetrics.field_paragraphs;
  const isSingleMetric = metricItems.length === 1;

  const {
    paragraphSingle, paragraphMultiple,
    headerSingle, headerMultiple,
  } = useLayoutVariables('paragraphMetrics');

  const classes = c('Paragraph', 'ParagraphMetrics', `ParagraphMetrics--${isSingleMetric ? 'single' : 'multiple'}`);
  const headerClasses = c('ParagraphMetrics__header', isSingleMetric ? headerSingle : headerMultiple);
  const metricItemClasses = c('ParagraphMetrics__subparagraphs', isSingleMetric ? paragraphSingle : paragraphMultiple);

  return (
    <div id={id} className={classes}>
      <Container>
        {(title || body) && (
          <div className="row">
            <div className={headerClasses}>
              {title && (
                <h2>{title}</h2>
              )}

              {body && (
                <WysiwygField
                  className="ParagraphMetrics__body"
                  html={body}
                />
              )}
            </div>
          </div>
        )}

        {metricItems.length > 0 && (
          <div className="row">
            <div className={metricItemClasses}>
              {metricItems.map((metricItem) => {
                const targetId = metricItem.target_id;

                return (
                  <Paragraph
                    key={`paragraph:${targetId}`}
                    id={targetId}
                    entity={Immutable.fromJS(metricItem.entity)}
                  />
                );
              })}
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ParagraphMetrics;
